<style scoped>

  .ui.segment {
    min-height: 400px;
  }

</style>

<template>
  
  <div>

    <div class="ui segment" :class="{ loading }">

      <div class="ui form">
        <div class="fields">
          <div class="two wide field">
            <label class="form-label">Data Inicial</label>
            {{ $formatDate(filter.startDate) }}
          </div>
          <div class="two wide field">
            <label class="form-label">Data Final</label>
            {{ $formatDate(filter.endDate) }}
          </div>    
          <div class="three wide field">
            <label class="form-label">Período de Pagamento</label>
            {{ paymentPeriod }}
          </div>      
          <div v-if="filter.customer" class="nine wide field">
            <label class="form-label">Cliente</label>
            {{ filter.customer.shortName }}
          </div>
        </div>
      </div>

      <table v-if="customers.length > 0" class="ui celled selectable tablet stackable table m-t-30">
        <thead v-if="$isDesktop">
          <tr>
            <th>Nome</th>
            <th>Laudos</th>
            <th>Valor Recebido</th>
            <th>Valor a Receber</th>            
          </tr>  
        </thead>
        <tbody>
          <tr v-for="(customer, index) in customers" @click="onSelectCustomer(index)">
            <td>
              <strong class="mobile-only">Nome: </strong> 
              <i class="circle blue icon m-r-10" :class="{ check: customer.selected, outline: !customer.selected }"></i>
              {{ customer.name }}
            </td>
            <td>
              <strong class="mobile-only">Laudos: </strong> {{ $formatInteger(customer.certsCount) }}
            </td>
            <td>
              <strong class="mobile-only">Valor Recebido: </strong> R$ {{ $formatCurrency(customer.receivedValue) }}   
            </td>
            <td>
              <strong class="mobile-only">Valor a Receber: </strong> R$ {{ $formatCurrency(customer.invoiceableValue) }}   
            </td>            
          </tr>                
        </tbody>
      </table>

      <p v-if="!loading && customers.length == 0" class="grey text m-t-30">
        <i class="info circle icon"></i> Nenhum cliente encontrado
      </p>

    </div>

    <button class="ui basic button" @click="$emit('onBack')">
      <i class="arrow left icon"></i> Voltar
    </button>

    <button class="ui right floated blue button" :class="{ disabled: !selectedCustomer }" 
      @click="$emit('onForward', selectedCustomer)">
      Avançar <i class="arrow right icon"></i> 
    </button>

  </div>

</template>

<script>

  import FinancialService from "@/services/financial-service"
  import CustomerInvoiceService from "@/services/customer-invoice-service"

  export default {
    
    name: "CustomerStep",

    data() {
      return {
        loading: true,
        customers: [],
        selectedCustomer: null,
        service: new CustomerInvoiceService(),
      }
    },

    props: ["filter"],

    mounted() {
      this.loadCustomers()
    },

    computed: {

      paymentPeriod() {

        const label = this.filter.paymentPeriod == "*" ? "Todos" : FinancialService.PAYMENT_PERIOD[this.filter.paymentPeriod].label

        return label
      }
    },

    methods: {

      async loadCustomers() {

        this.loading = true

        try {

          let filter = this.$cloneObject(this.filter)

          if (filter.customer)
            filter.customerId = filter.customer.id

          this.customers = await this.service.getUninvoicedCustomers(filter)

          if (this.customers.length == 1) {
            this.customers[0].selected = true
            this.selectedCustomer = this.customers[0]
          }  
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      onSelectCustomer(row) {

        let customers = this.customers.slice()

        for (let index = 0; index < customers.length; index++) {
          
          customers[index].selected = (index == row)
          
          if (customers[index].selected)
            this.selectedCustomer = customers[index]
        }

        this.customers = customers
      },
    },
  }

</script>